export const getCurrencySymbol = value => {
    let result = '';
    if (typeof value === 'number') {
        switch (parseInt(value)) {
            case 840:
                result = '$';
                break;
            case 980:
                result = '₴';
                break;
            case 978:
                result = '€';
                break;
            case 643:
                result = '₽';
                break;
            default:
                result = value;
                break;
        }
    }
    if (typeof value === 'string') {
        switch (String(value).toUpperCase()) {
            case 'USD':
                result = '$';
                break;
            case 'UAH':
                result = '₴';
                break;
            case 'EUR':
                result = '€';
                break;
            case 'RUB':
                result = '₽';
                break;
            default:
                result = value;
                break;
        }
    }
    return result;
};
